import { render, staticRenderFns } from "./AppFeaturesComparison.vue?vue&type=template&id=515888c1&"
import script from "./AppFeaturesComparison.vue?vue&type=script&lang=js&"
export * from "./AppFeaturesComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FeatureCompareTable: require('/opt/build/repo/components/elements/FeatureCompareTable.vue').default})
